const capitalizeFieldId = (fieldId) =>
  fieldId.charAt(0).toUpperCase() + fieldId.slice(1);

export const buildImageHandlersFromProps = (props, fields) => {
  return fields.reduce((handlers, field) => {
    const capitalized = capitalizeFieldId(field.id);
    handlers[field.id] = {
      onUpload: props[`handle${capitalized}Upload`],
      onDelete: props[`handle${capitalized}Delete`],
      onFileError: props[`handle${capitalized}FileError`],
      progress: props[`${field.id}Progress`],
      validationError: props[`${field.id}ValidationError`]
    };
    return handlers;
  }, {});
};
